import { environment } from "src/environments/environment";

export class AppConstants {
  public static readonly PARAM_RETURN_URL = "returnUrl";
  public static readonly PARAM_NO_ACCOUNT = "noAccount";
  public static readonly PARAM_EMAIL = "email";
  public static readonly PARAM_CHANGE_USER = "changeUser";
  public static readonly PARAM_IS_MOBILE_APP = "isMobileApp";
  public static readonly PARAM_EDIT_GROUP_CODE = "editGroupCode";
  public static readonly PARAM_USER_ROLE = "role";
  public static readonly PARAM_BEACON_ARTICLE_ID = "articleId";

  public static readonly PARAM_ID_TOKEN = "id_token";
  public static readonly PARAM_NONCE = "nonce";
  public static readonly PARAM_STATE = "state";

  public static readonly COOKIE_TOKEN = "X_EEMO_AUTH";

  public static readonly DATE_FORMAT = "dd/MM/yyyy";
  public static readonly DATE_TIME_FORMAT = "dd/MM/yyyy HH:mm:ss";

  public static readonly FORM_PATTERN_PASSWORD =
    "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,50}";
  public static readonly FORM_PATTERN_CODE = "^[_A-Z0-9]{1,50}$";
  public static readonly FORM_PATTERN_POSITIVE_INTEGER = "^[0-9]*$";
  public static readonly FORM_PATTERN_INTEGER = "^-?[0-9]*$";
  public static readonly FORM_PATTERN_POSITIVE_DECIMAL =
    "^([0-9]*[,|.])?[0-9]*$";
  public static readonly FORM_PATTERN_DECIMAL = "-?([0-9]*[,|.])?[0-9]*$";

  public static readonly STORAGE_KEY_JWT = "JWT";
  public static readonly STORAGE_KEY_JWT_NONCE = "JWT_NONCE";
  public static readonly STORAGE_KEY_IDP = "IDP";
  public static readonly STORAGE_KEY_CURRENT_USER = "USER";
  public static readonly STORAGE_KEY_EMAIL_VALIDATED = "EMAIL_VALIDATED";
  public static readonly STORAGE_KEY_USER_LOGIN = "USER_LOGIN";
  public static readonly STORAGE_KEY_SUBSCRIPTION_STATE = "SUBSCRIPTION_STATE";

  public static readonly STORAGE_KEY_CONNECTORS_AVAILABLE = "USER_CONNECTORS";
  public static readonly STORAGE_KEY_USER_PREFERENCES = "USER_PREFERENCES";
  public static readonly STORAGE_KEY_SHOW_APP_DOWNLOAD = "SHOW_APP_DOWNLOAD";

  public static readonly SWIPER_OVERLAY_DIV_ID = "swiper-overlay-container";
}

export function getApiBaseUrl() {
  return window.location.hostname === environment.demoHostname
    ? "demo/api"
    : "api";
}

export function getBaseAbsoluteUrl() {
  return window.location.protocol + "//" + window.location.host + "/";
}
